// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2149g","delete":"styles_delete__1sFUz","update":"styles_update__2zdc_","add":"styles_add__N3wAH"};